<template>
  <div>
    <AppHeader />
    <div class="search-activities">
      <div class="search-activities__preview">
        <v-container class="search-activities__preview-inner">
          <v-layout row>
            <v-flex>
              <h1
                class="search-activities__preview-title display-1 white--text"
              >
                Activities
              </h1>
              <v-flex md12>
                <div class="search-activities__search">
                  <div class="search-activities__search-inner">
                    <v-autocomplete
                      v-model="searchActivity"
                      :items="getActivities"
                      item-value="id"
                      item-text="name"
                      label="Search activities"
                      height="56px"
                      single-line
                      solo
                      depressed
                      clearable
                      color="teal lighten-2"
                      prepend-inner-icon="fas fa-search fa-1x"
                      class="search-activities__search-input"
                    />
                  </div>
                </div>
              </v-flex>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
      <v-container
        v-if="loaded"
        class="search-activities__search-results grid-list-xl"
      >
        <v-layout row wrap>
          <v-flex
            v-for="activity in filteredActivities"
            :key="activity.id"
            xs12
            md4
            class="search-activities__search-item"
          >
            <v-card :to="{ name: 'activity', params: { id: activity.id } }">
              <v-img
                class="white--text"
                :src="activity.image"
                :aspect-ratio="16 / 9"
              />
              <v-card-title>
                <span class="search-activities__card-title">
                  {{ activity.name }}
                </span>
              </v-card-title>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <div v-else class="text-xs-center">
        <v-progress-circular :size="50" color="primary" indeterminate />
      </div>
      <br />
      <br />
      <br />
      <br />
      <br />
      <BottomNavigation />
    </div>
  </div>
</template>

<script>
import AppHeader from "../components/AppHeader";
import BottomNavigation from "../components/BottomNavigation";
//  import { ACTIVITIES_REQUEST } from '../store/actions/activities';
import { mapGetters } from "vuex";

export default {
  name: "Search",
  components: {
    AppHeader,
    BottomNavigation
  },
  data() {
    return {
      searchActivity: "",
      loaded: false
    };
  },
  computed: {
    ...mapGetters("activity", ["getActivities"]),
    filteredActivities: function() {
      if (this.searchActivity) {
        return this.getActivities.filter(
          activity => activity.id === this.searchActivity
        );
      }
      return this.getActivities;
    }
  },
  mounted() {
    this.$store
      .dispatch("activity/activitiesRequest")
      .then(() => {
        this.loaded = true;
      })
      .catch(err => {});
  }
};
</script>

<style scoped>
.search-activities__preview {
  display: flex;
  background-color: #272727;
  margin-bottom: 45px;
}

.search-activities__preview-inner {
  position: relative;
  /* padding-top: 45px; */
  padding-bottom: 35px;
}

.search-activities__preview-title {
}

.search-activities__search {
  position: absolute;
  bottom: -55px;
  left: 0;
  width: 100%;
  padding: 0 15px;
}

.search-activities__search-inner {
  display: flex;
}

.search-activities__search-input {
}

.search-activities__search-button {
  width: 56px;
  height: 56px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  margin: 0;
  padding-left: 0;
  padding-right: 0;
  position: relative;
  left: -2px;
}

.search-activities__search-item {
  /*padding: 15px;*/
}

.search-activities__card-title {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 15px;
  min-height: 30px;
}
.v-progress-circular {
  margin: 1rem;
}
</style>
